// Copyright ©️ 2026 eVolve MEP, LLC

import { type Facility, useEvolvePaginatedGet } from '@evolvemep/api-ts';

import {
  SearchableSelect,
  type SearchableSelectProps,
} from 'components/Mantine/TypeSafeSelect/PaginatedSelectors/SearchableSelect';

type Props = Omit<
  SearchableSelectProps<'shop/facility', Facility, 'facilityId'>,
  'idKey' | 'paginatedGet' | 'getItemLabel' | 'value' | 'onChange'
> & {
  value?: Facility | null;
  onChange: (facility: Facility | null) => void;
};

export const FacilitySelect = ({ placeholder = 'Select a facility...', ...props }: Props) => {
  const paginatedFacility = useEvolvePaginatedGet('shop/facility');

  return (
    <SearchableSelect<'shop/facility', Facility, 'facilityId'>
      idKey="facilityId"
      paginatedGet={paginatedFacility}
      getItemLabel={(f) => f.facilityName}
      placeholder={placeholder}
      {...props}
    />
  );
};
